import { render, staticRenderFns } from "./EditCtaSettings.vue?vue&type=template&id=ed94df6e&scoped=true&"
import script from "./EditCtaSettings.vue?vue&type=script&lang=js&"
export * from "./EditCtaSettings.vue?vue&type=script&lang=js&"
import style0 from "./EditCtaSettings.vue?vue&type=style&index=0&id=ed94df6e&scoped=scss&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed94df6e",
  null
  
)

export default component.exports